import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export const Marquee = () => {
  const { t } = useI18n();
  const words = t("home.marquee");
  const items = Array.isArray(words) ? words : [];
  const row = [...items, ...items];

  return (
    <div
      className="relative overflow-hidden border-y border-navy/10 bg-white py-4 edge-fade sm:py-5"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee gap-8 sm:gap-12">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-8 sm:gap-12">
            <span className="whitespace-nowrap font-display text-base font-medium uppercase tracking-[0.16em] text-navy/70 sm:text-2xl sm:tracking-[0.18em]">
              {w}
            </span>
            <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
};
